import { c as _c } from "react/compiler-runtime";
import SignInView from "@repo/ui/components/auth/SignInView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { signInSearchSchema } from "@/lib/schemas/searchParams.schema";
import { decodeStatusParam } from "@/lib/utils/statusParam";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/_auth/logga-in")({
  component: SignInPage,
  validateSearch: signInSearchSchema
});
function SignInPage() {
  const $ = _c(17);
  const navigate = useNavigate();
  const search = Route.useSearch();
  const t0 = search.meddelande || search.bekraftelsemeddelande;
  let t1;
  if ($[0] !== t0) {
    t1 = decodeStatusParam(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const decoded = t1;
  let t2;
  if ($[2] !== decoded || $[3] !== search.meddelande) {
    t2 = decoded ? {
      message: decoded,
      variant: search.meddelande ? "success" : "confirmation"
    } : undefined;
    $[2] = decoded;
    $[3] = search.meddelande;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const statusMessage = t2;
  let t3;
  let t4;
  let t5;
  if ($[5] !== navigate) {
    t3 = () => navigate({
      to: "/"
    });
    t4 = () => navigate({
      to: "/skapa-konto"
    });
    t5 = () => navigate({
      to: "/begar-aterstall-losenord"
    });
    $[5] = navigate;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  const t6 = statusMessage;
  let t7;
  if ($[9] !== navigate) {
    t7 = () => navigate({
      to: "/logga-in"
    });
    $[9] = navigate;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = /*#__PURE__*/_jsx(SignInView, {
      authClient: authClient,
      onSuccess: t3,
      onRegister: t4,
      onForgotPassword: t5,
      statusMessage: t6,
      onStatusMessageAction: t7
    });
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}